// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","content":"Footer_content__2lZHa","privacyPolicy":"Footer_privacyPolicy__3LdrC","info":"Footer_info__2h2NT"};